@if (visible) {
  <div class="card">
    <div class="font-semibold text-xl">Qualifikation</div>
    <div class="text-surface-400 text-sm mb-4">Startaufstellung für Renntag 1 · Rating bis zum ersten Rennen</div>
    <div class="flex justify-center">
      <div class="inline-block shadow-2xl rounded-lg overflow-hidden">
        <p-table
          class="racing-table"
          [value]="entries"
          dataKey="player_id"
          [rowHover]="true"
          [showGridlines]="false"
          responsiveLayout="scroll"
          size="small"
        >
          <ng-template #header>
            <tr>
              <th colspan="4" class="table-header" style="text-align: center;">
                Qualifikation - {{ seasonName || 'Season ' + season }}
              </th>
            </tr>
            <tr>
              <th style="text-align: center;"><i class="pi pi-flag"></i></th>
              <th style="min-width: 19rem"><i class="pi pi-user"></i> Fahrer</th>
              <th style="text-align: center;"><i class="pi pi-stopwatch"></i> Beste Runde</th>
              <th style="text-align: center;">Rating</th>
            </tr>
          </ng-template>
          <ng-template #body let-entry>
            <tr [routerLink]="['/playerDetails', entry.player_id]" style="cursor: pointer;">
              <td class="index-cell" style="text-align: center;">P{{ entry.rank }}</td>
              <td>
                <b>{{ entry.name_gt7 }}</b>
                @if (entry.name_gt7 !== entry.name_psn) {
                  <span class="text-surface-400 text-sm ml-1">(PSN: {{ entry.name_psn }})</span>
                }
              </td>
              <td style="text-align: center;" class="font-mono">{{ lapTime(entry) }}</td>
              <td style="text-align: center;"><b>{{ entry.initial_rating }}</b></td>
            </tr>
          </ng-template>
        </p-table>
      </div>
    </div>
  </div>
}
